import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import VueAxios from 'vue-axios'

// 引入iconf
import './assets/icon/iconfont.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import utils from './plugins/utils.js'
import './plugins/element.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';


// Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$baseUrl = process.env.BASE_URL
Vue.prototype.$utils = utils

Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
  }
}).$mount('#app')

